import * as React from 'react';
import {
  GalleryElement,
  Image,
  ImageSizeVariant,
  TypographyVariant,
  useTheme,
} from '@secretescapes/falcon';
import {
  GridContainer,
  GridItemWrapper,
  ImageWrapper,
  StyledTypography,
} from './GalleryModal.styles';

interface Props {
  images: GalleryElement[];
  focusedImageIndex?: number;
  onImageClick?: (index: number) => void;
}

export const ImageGrid = React.forwardRef<HTMLDivElement, Props>(
  ({ images, focusedImageIndex, onImageClick }: Props, ref) => {
    const { color } = useTheme();

    return (
      <GridContainer>
        {images.map((image, index) => {
          return (
            <GridItemWrapper key={image.id} onClick={() => onImageClick?.(index)}>
              <ImageWrapper
                {...(focusedImageIndex === index && {
                  'data-testid': 'focused-image',
                  ref,
                })}
              >
                <Image
                  className="grid__image"
                  alt=""
                  size={ImageSizeVariant.full}
                  objectFit="cover"
                  srcSet={[
                    {
                      src: image.imgUrl,
                    },
                  ]}
                  loading="lazy"
                />
              </ImageWrapper>
              <StyledTypography variant={TypographyVariant.body} color={color.blackText}>
                {image.title}
              </StyledTypography>
            </GridItemWrapper>
          );
        })}
      </GridContainer>
    );
  }
);

ImageGrid.displayName = 'ImageGrid';
